import login from './login';

export default {
  language: 'zh-TW',
  country: 'tw',
  name: '繁體中文',
  embeddedLocale: login,
};
